import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ChangePasswordPage } from '@modals/profile/change-password/change-password.page';
import { UpdateProfilePage } from '@modals/profile/update-profile/update-profile.page';

@Component({
  selector: 'app-menu-profile',
  templateUrl: './menu-profile.page.html',
  styleUrls: ['./menu-profile.page.scss']
})
export class MenuProfilePage implements OnInit {
  @Input() data: any

  constructor(public modalController: ModalController) {}

  ngOnInit() {}

  async openModalClave() {
    const modal = await this.modalController.create({
      component: ChangePasswordPage,
      componentProps: {
        userData: this.data
      }
    })

    modal.onDidDismiss().then((data) => {
      this.closeModal()
    })

    return await modal.present()
  }

  async openModalDatos() {
    const modal = await this.modalController.create({
      component: UpdateProfilePage,
      componentProps: {
        userData: this.data
      }
    })

    modal.onDidDismiss().then((data) => {
      this.closeModal()
    })

    return await modal.present()
  }

  async closeModal() {
    await this.modalController.dismiss()
  }
}
